<template>
    <InputField 
        :id="id"
        ref="child" 
        :placeholder="placeholder" 
        icon-left="icon icon-search" 
        :name="name" 
        :error="error"
        :disabled="disabled"
        :has-clear="hasClear"
        :initialValue="initialValue"
        @update:inputValue="updateInput"
        @update:hasFocus="focusHandler"
        @update:blurred="blurHandler"
        @keyDownEnter="$emit('keyEnter')"
     />
</template>

<script setup>
import { ref } from 'vue';
import InputField from '../InputField/InputField.vue';

const props = defineProps({
    name: {
        type: String,
        required: true,
    },
    placeholder: {
        type: String,
        default: 'Search',
    },
    error: {
        type: Object,
        default: ()=> {},
    },
    disabled: {
        type: String,
        default: ''
    },
    hasClear: {
        type: String,
        default: 'true'
    },
    initialValue: {
        type: String,
        default: '',
    },
    id: {
        type: String,
        default: Math.random().toString(36).substring(2, 12),
    },
});

const emit = defineEmits(['update:inputValue', 'update:hasFocus', 'update:blurred', 'keyEnter']);

const emitHandler = (name, value) => {
  emit(name, value);
}

const inputValue = ref('');
const child = ref(null);

const updateInput = (value) => {
    inputValue.value = value
    emitHandler( 'update:inputValue', value)
}

const focusHandler = (e) => {
    emitHandler( 'update:hasFocus', e)
}

const blurHandler = (e) => {
    emitHandler( 'update:blurred', e)
}

const clearInput = () => {
    child.value?.clearInput()
}


defineExpose({
  clearInput: clearInput,
})

</script>